import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type TaskPerformanceFragment = { entityId: string, id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, type: Types.PerformanceTypeEnum, entityType: Types.PerformanceEntityTypeEnum, isAvailable: boolean, enrolmentInfo?: { dueDate?: string | null } | null };


export type TaskPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const TaskPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment TaskPerformance on TaskPerformanceType {
  entityId
  id
  status
  estimatedTimeSpent
  type
  entityType
  isAvailable
  enrolmentInfo {
    dueDate
  }
}
    `;